export default __webpack_public_path__ + "static/media/cpv_41_water.c85e3f35.svg";